import axiosInstance from '../../../config/axiosInstance';
import type {
  PlatformActivityEventsResponse,
  PlatformAdminAuditEventsResponse,
  PlatformAdminContext,
  PlatformAdminOverview,
  PlatformAdminTenantsResponse,
  PlatformAdminUsersResponse,
  PlatformObservabilityEventsResponse,
  PlatformOwnerBootstrapStatus,
} from '../types/platformAdmin';

export async function getPlatformOwnerBootstrapStatus(): Promise<PlatformOwnerBootstrapStatus> {
  const { data } = await axiosInstance.get<PlatformOwnerBootstrapStatus>(
    '/platform-admin/bootstrap-owner/status'
  );

  return data;
}

export async function bootstrapPlatformOwner(): Promise<PlatformAdminContext> {
  const { data } = await axiosInstance.post<PlatformAdminContext>(
    '/platform-admin/bootstrap-owner'
  );

  return data;
}

export async function getPlatformAdminContext(): Promise<PlatformAdminContext> {
  try {
    const { data } = await axiosInstance.get<PlatformAdminContext>(
      '/platform-admin/context'
    );

    return data;
  } catch (error: any) {
    // IND-056: sin acceso de plataforma es una respuesta, no un error: así se
    // guarda y no se vuelve a pedir cada vez que se monta una pantalla.
    if (error?.response?.status === 403) {
      return { is_platform_admin: false, access: null, effective_permissions: [] };
    }
    throw error;
  }
}

export async function getPlatformAdminOverview(): Promise<PlatformAdminOverview> {
  const { data } = await axiosInstance.get<PlatformAdminOverview>(
    '/platform-admin/overview'
  );

  return data;
}

export async function getPlatformAdminUsers(params?: {
  limit?: number;
  offset?: number;
  search?: string;
}): Promise<PlatformAdminUsersResponse> {
  const { data } = await axiosInstance.get<PlatformAdminUsersResponse>(
    '/platform-admin/users',
    { params }
  );
  return data;
}

export async function getPlatformAdminTenantUsers(
  tenantId: string,
  params?: {
    limit?: number;
    offset?: number;
  }
): Promise<PlatformAdminUsersResponse> {
  const { data } = await axiosInstance.get<PlatformAdminUsersResponse>(
    `/platform-admin/tenants/${encodeURIComponent(tenantId)}/users`,
    { params }
  );
  return data;
}

export async function getPlatformAdminTenants(): Promise<PlatformAdminTenantsResponse> {
  const { data } = await axiosInstance.get<PlatformAdminTenantsResponse>(
    '/platform-admin/tenants'
  );

  return data;
}

export async function getPlatformAdminObservabilityEvents(params?: {
  limit?: number;
  status?: string;
  severity?: string;
  app_module?: string;
}): Promise<PlatformObservabilityEventsResponse> {
  const { data } = await axiosInstance.get<PlatformObservabilityEventsResponse>(
    '/platform-admin/observability-events',
    {
      params,
    }
  );

  return data;
}

export async function getPlatformAdminActivityEvents(params?: {
  limit?: number;
  outcome?: string;
  severity?: string;
  status?: string;
  app_module?: string;
  area?: string;
  operation?: string;
  event_type?: string;
  actor_user_id?: string;
  actor_email?: string;
  pricing_account_id?: string;
  pricing_account_key?: string;
  industrial_tenant_id?: string;
  poker_tenant_id?: string;
  platform_tenant_id?: string;
  tenant_ref?: string;
  created_from?: string;
  created_to?: string;
}): Promise<PlatformActivityEventsResponse> {
  const { data } = await axiosInstance.get<PlatformActivityEventsResponse>(
    '/platform-admin/activity-events',
    {
      params,
    }
  );

  return data;
}

export async function getPlatformAdminAuditEvents(params?: {
  limit?: number;
}): Promise<PlatformAdminAuditEventsResponse> {
  const { data } = await axiosInstance.get<PlatformAdminAuditEventsResponse>(
    '/platform-admin/audit-events',
    {
      params,
    }
  );

  return data;
}